import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Inject, ViewEncapsulation } from '@angular/core';
//import { CalendarEvent } from 'angular-calendar';
//import { CalendarEventAction, CalendarEventTimesChangedEvent } from 'angular-calendar';
import { ManikEntityFE } from '../../manik-library/ManikEntityFE';
import { ManikEntityService } from '../../manik-library/ManikEntityService';
import { Subject } from 'rxjs';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-booking-calendar',
  templateUrl: './booking-calendar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})

export class BookingCalendarComponent extends ManikEntityFE implements OnInit {

  populateControls(): void {
    throw new Error("Method not implemented.");
  }
  refreshDataGrid(param: any): void {
    throw new Error("Method not implemented.");
  }
  WebSiteMetaData: any = JSON.parse(sessionStorage.getItem("SiteMetaData"));
  view: string = 'month';
  viewDate: Date = new Date();
  locale: string = 'en';
  events: any[] = [];// CalendarEvent[] = [];
  viewDateChange: EventEmitter<Date> = new EventEmitter();
  refresh: Subject<any> = new Subject();
  constructor(@Inject(DOCUMENT) public document, public _manikEntityService: ManikEntityService) {
    super(document);
  }

  ngOnInit() {
    if (this.view == 'day') this.GetBookedSlots(this.getDateString(this.viewDate), this.getDateString(this.viewDate));
    else this.ChangeTimeFrame();
  }

  GetBookedSlots(startdate, enddate) {
    this.events = [];
    this.updateFilterParams(this.WebSiteMetaData.BizHandle, startdate, enddate);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("BIZ.BOOKINGS", "BUSINESS.BOOKINGS", "BOOKING", this.WebSiteMetaData.PC))
      .subscribe(data => {
        let resp = data.ManikJSon[0].JSon0;
        for (let i = 0; i < resp.length; i++) {
          let startdate = new Date(this.getDateTimeString(resp[i].ServiceDate.split('T')[0], resp[i].TimePointText));
          this.events.push({ title: resp[i].CustomerName, start: startdate });
        }
        this.refresh.next();
      });
  }

  public getDateTimeString(date: any, timeS: any) {
    date = this.getManikDateString(date);
    var myDate = new Date(date);
    var d = myDate.getDate();
    var m = myDate.getMonth();
    m += 1;
    var y = myDate.getFullYear();
    date = (y + "-" + (m < 10 ? '0' + m : m) + "-" + (d < 10 ? '0' + d : d));

    var time = timeS.toUpperCase();
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM = time.match(/\s(.*)$/)[1];
    if (AMPM == "PM" && hours < 12) hours = hours + 12;
    if (AMPM == "AM" && hours == 12) hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return date + 'T' + sHours + ":" + sMinutes + ':00';
  }

  protected getManikDateString(date: any): string {
    let newDate: Date = new Date(date);
    return ((newDate.getMonth() + 1) + '-' + newDate.getDate() + '-' + newDate.getFullYear());
  }

  protected getDateString(date: any): string {
    let newDate: Date = new Date(date);
    var d = newDate.getDate();
    var m = newDate.getMonth();
    m += 1;
    var y = newDate.getFullYear();
    date = (y + "-" + (m < 10 ? '0' + m : m) + "-" + (d < 10 ? '0' + d : d));
    return date;
  }

  ChangeTimeFrame() {
    let startdate = new Date(this.viewDate);
    let enddate = new Date(this.viewDate);
    switch (this.view) {
      case 'month':
        startdate.setDate(1);
        if (enddate.getMonth() + 1 == 2) {
          let year = enddate.getFullYear();
          if ((year % 4) % 2 == 0) {
            if ((year % 100) % 2 == 0) {
              if ((year % 400) % 2 == 0) {
                enddate.setDate(29);
              }
              else {
                enddate.setDate(28);
              }
            }
            else {
              enddate.setDate(29);
            }
          }
          else {
            enddate.setDate(28);
          }
        }
        else {
          if (enddate.getMonth() <= 6) {
            if (enddate.getMonth() % 2 == 0) {
              enddate.setDate(31);
            }
            else {
              enddate.setDate(30);
            }
          }
          else {
            if (enddate.getMonth() % 2 == 0) {
              enddate.setDate(30);
            }
            else {
              enddate.setDate(31);
            }
          }
        }
        break;
      case 'week':
        startdate.setDate(startdate.getDate() - startdate.getDay());
        enddate.setDate(enddate.getDate() + 6 - enddate.getDay());
        break;
      case 'day':
        break;
    }
    this.GetBookedSlots(this.getDateString(startdate), this.getDateString(enddate));
  }
}
